export const authenticate = (authService, $timeout, $state, GlobalRedirects) => {
    "ngInject";
    return authService.protectRoute()
        .then(data => {
            if (!data) {
                $timeout(() => $state.go(GlobalRedirects.LOGIN), 0);
            }
        });
};

export const logout = (authService, $timeout, $state, GlobalRedirects) => {
    "ngInject";
    return authService.logOut()
        .then(data => {
            if (data) {
                $timeout(() => $state.go(GlobalRedirects.AFTER_LOGOUT), 0);
                return false;
            }
        });
};


// WEBPACK FOOTER //
// ./client/app/core/core.middleware.js